









import store from '@/store';
import SelectBox from '@/views/atoms/SelectBox.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import moment from 'moment'
import Global from '@/common/global.js'

export default

  components: {
    SelectBox
    BlueButton
  }

  data: () ->
    year: moment().format('yyyy')
    yearList: Global.yearList()

  methods: {
    click: (e) ->
      param = 
        year: store.getters.getPostParam.year
      @$emit('search', param)
  }
